import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { TemplateStoreService } from '../services/template-store.service';
import { ClassroomCourse } from '@modules/course/classroom/models';
import { Guid } from '@core/utils/guid';

@Injectable()
export class TemplateCoursesResolver implements Resolve<ClassroomCourse[]> {
  constructor(private templateStore: TemplateStoreService) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ClassroomCourse[]> {
    const templateId = route.params.id;

    if (Guid.IsGuid(templateId)) {
      return this.templateStore.getClassroomCourses().pipe(
        tap((classrooms) => {
          if (!classrooms.length) {
            this.templateStore.fetchClassroomCourse(templateId);
          }
        }),
        first()
      );
    } else {
      return of(null);
    }
  }
}
